import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'td-wb-page-header-toolbar',
  template: '<ng-content></ng-content>',
  styleUrls: ['./page-header-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderToolbarComponent {
}
